registerComponent("sections/history-content", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Sem comportamento próprio, em 2020 e hoje: o arquivo só tinha o cabeçalho.
 *
 * ⚠️ O `.read-more` do celular está COMENTADO no Blade (bloco `{{-- --}}` em
 * torno do `<button class="read-more">`), e as regras `.read-more` /
 * `.svg-arrow-down-seemore` do LESS são código morto desde então — como o
 * `.mobile-hidden`, cujo bloco também está comentado no LESS. Transpostas
 * mesmo assim, porque a fase é de transposição e não de remoção; a remoção é
 * da Fase 9, pelo protocolo.
 */

});
